"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergedVisit = exports.MergedPage = exports.MergedDomain = exports.MergedStudySpec = exports.StudyActionAudit = exports.StudyMailTemplate = exports.StudyUserRole = exports.StudyUserSummary = exports.StudyUser = exports.Study = exports.StudyEssential = exports.StudyMailTemplateType = exports.StudyAction = exports.StudyStatus = void 0;
var StudyStatus;
(function (StudyStatus) {
    StudyStatus["Wait"] = "WAIT";
    StudyStatus["Ongoing"] = "ONGOING";
    StudyStatus["Closed"] = "CLOSED";
})(StudyStatus = exports.StudyStatus || (exports.StudyStatus = {}));
var StudyAction;
(function (StudyAction) {
    StudyAction["Lock"] = "LOCK";
    StudyAction["Unlock"] = "UNLOCK";
    StudyAction["Close"] = "CLOSE";
    StudyAction["Reopen"] = "REOPEN";
})(StudyAction = exports.StudyAction || (exports.StudyAction = {}));
var StudyMailTemplateType;
(function (StudyMailTemplateType) {
    StudyMailTemplateType["SaeReport"] = "SAE_REPORT";
    StudyMailTemplateType["AeReport"] = "AE_REPORT";
})(StudyMailTemplateType = exports.StudyMailTemplateType || (exports.StudyMailTemplateType = {}));
class StudyEssential {
}
exports.StudyEssential = StudyEssential;
class Study {
}
exports.Study = Study;
class StudyUser {
}
exports.StudyUser = StudyUser;
class StudyUserSummary {
}
exports.StudyUserSummary = StudyUserSummary;
class StudyUserRole {
}
exports.StudyUserRole = StudyUserRole;
class StudyMailTemplate {
}
exports.StudyMailTemplate = StudyMailTemplate;
class StudyActionAudit {
}
exports.StudyActionAudit = StudyActionAudit;
class MergedStudySpec {
}
exports.MergedStudySpec = MergedStudySpec;
class MergedDomain {
}
exports.MergedDomain = MergedDomain;
class MergedPage {
}
exports.MergedPage = MergedPage;
class MergedVisit {
}
exports.MergedVisit = MergedVisit;
//# sourceMappingURL=study.js.map